import { gql } from "@apollo/client";

export const DELETE_EVENT = gql`
  mutation adminDeleteEvent($id: String!) {
    adminDeleteEvent(id: $id) {
      status
    }
  }
`;

export const EDIT_EVENT = gql`
  mutation adminEditEvent($id: String!, $input: EditEventInput!) {
    adminEditEvent(id: $id, input: $input) {
      status
    }
  }
`;

export const REPUBLISH_EVENT = gql`
  mutation adminRepublishEvent($eventId: String!) {
    adminRepublishEvent(eventId: $eventId) {
      status
    }
  }
`;

export const VALIDATE_USERS_FOR_EMAIL_BULK_INVITE = gql`
  mutation validateUsersForEmailBulkInvite($eventId: String!, $input: BulkInviteWithEmailsInput!) {
    validateUsersForEmailBulkInvite(eventId: $eventId, input: $input) {
      userIds
      warningMessages
    }
  }
`;

export const BULK_INVITE_WITH_USER_IDS = gql`
  mutation bulkInviteWithUserIds($eventId: String!, $input: BulkInviteWithUserIdsInput!) {
    bulkInviteWithUserIds(eventId: $eventId, input: $input) {
      warningMessages
      invitedUserIds
    }
  }
`;

export const VALIDATE_FOR_SELECTION_BULK_INVITE = gql`
  mutation validateForSelectionBulkInvite($eventId: String!, $filters: AdminFilterUsersInput!) {
    validateForSelectionBulkInvite(eventId: $eventId, filters: $filters) {
      eventTitle
      userIds
      warningMessages
    }
  }
`;

/**
 * The audience a share would reach: no capacity check (a full event is still
 * shareable), but with the event passed the server runs its own share dry run,
 * so `userIds` is who will actually receive it.
 */
export const ADMIN_SELECTION_USER_IDS = gql`
  mutation adminSelectionUserIds($filters: AdminFilterUsersInput!, $eventId: String) {
    adminSelectionUserIds(filters: $filters, eventId: $eventId) {
      userIds
      totalMatched
      truncated
      cap
      eligibleCount
      alreadySharedCount
      notAllowedCount
      inactiveCount
    }
  }
`;

export const ADMIN_VALIDATE_BULK_UPLOAD_EVENTS = gql`
  mutation adminValidateBulkUploadEvents($input: BulkUploadEventsInput!) {
    adminValidateBulkUploadEvents(input: $input) {
      totalRows
      validationErrors {
        row
        eventTitle
        column
        message
      }
      inviteWarnings {
        row
        eventTitle
        column
        message
      }
    }
  }
`;

export const ADMIN_BULK_UPLOAD_EVENTS = gql`
  mutation adminBulkUploadEvents($input: BulkUploadEventsInput!) {
    adminBulkUploadEvents(input: $input) {
      createdCount
      createdEvents {
        row
        id
        title
      }
      validationErrors {
        row
        eventTitle
        column
        message
      }
      inviteWarnings {
        row
        eventTitle
        column
        message
      }
    }
  }
`;
